// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.amenities.units.RentalManagerUserPropertyUnitAmenityV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  UserPropertyUnitAmenityCreateResponseV2WebDto,
  UserPropertyUnitAmenityCreateV2RequestDto,
  UserPropertyUnitAmenityDeleteV2RequestDto,
} from '../..';

export const RentalManagerUserPropertyUnitAmenityV2WebApiHandler_create_Path =
  '/api/web/v2/users/properties/amenities/units/create';

/**
 * Create a free text unit amenity
 */
export const RentalManagerUserPropertyUnitAmenityV2WebApiHandler_create = (
  postData: UserPropertyUnitAmenityCreateV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    UserPropertyUnitAmenityCreateV2RequestDto,
    UserPropertyUnitAmenityCreateResponseV2WebDto
  >(
    {
      endpoint: RentalManagerUserPropertyUnitAmenityV2WebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};

export const RentalManagerUserPropertyUnitAmenityV2WebApiHandler_delete_Path =
  '/api/web/v2/users/properties/amenities/units/delete';

/**
 * Delete a free text unit amenity
 */
export const RentalManagerUserPropertyUnitAmenityV2WebApiHandler_delete = (
  postData: UserPropertyUnitAmenityDeleteV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyUnitAmenityDeleteV2RequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyUnitAmenityV2WebApiHandler_delete_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
